import {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import Swal from 'sweetalert2';
import headerimage from '../../assets/images/ascas.svg';
import ReportFormInputWithLabel from '../../Components/Global_Components/form/ReportFormInputWithLabel';
import TemplateTable from '../../Components/Global_Components/TemplateTable/TemplateTable';
import Headers from '../../Components/Header/Headers';
import {PrescriptionFooter} from '../../Components/Prescription Footer/PrescriptionFooter';
import {fetchPatientDetailsUuid, postPrescriptionTemplate} from '../../Redux/Thunk/Actions';
import './preoochecklist.scss';

export default function PreOPCheckList(props) {
  const [formData, setFormData] = useState({});
  const [show, setshow] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const patientId = useSelector(state => state.counter.patientid);
  const [appointmentData, setAppointmentData] = useState({
    p_uhid: '',
    name: '',
    date: '',
    time: '',
    status: 'Not Visited',
    notes: '',
    patient_id: ''
  });

  const [patientOne_UUId, setPatientOne_UUId] = useState('');

  const checkListHeaders = [
    {key: 'checklist', label: 'Checklist'},
    {key: 'result', label: 'Result'}
  ];

  const [checkListRows, setCheckListRows] = useState([
    {checklist: 'BLOOD GROUP', result: ''},
    {checklist: 'CBC', result: ''},
    {checklist: 'RFT', result: ''},
    {checklist: 'LFT', result: ''},
    {checklist: 'BT ,CT', result: ''},
    {checklist: 'PT INR', result: ''},
    {checklist: 'HIV', result: ''},
    {checklist: 'HBSAG', result: ''},
    {checklist: 'HCV', result: ''},
    {checklist: 'VDRL', result: ''},
    {checklist: 'TSH ,FT4', result: ''},
    {checklist: 'FBS/RBS', result: ''},
    {checklist: 'HBA1C', result: ''},
    {checklist: 'ECHO', result: ''},
    {checklist: 'ECG', result: ''},
    {checklist: 'CHEST X RAY IF NEEDED', result: ''},
    {checklist: 'PAC', result: 'DONE/NOT DONE'},
    {checklist: 'SURGERY DATE', result: ''},
    {checklist: 'SURGERY PLANNED', result: ''},
    {checklist: 'HOSPITAL', result: ''},
    {checklist: 'CO SURGEON', result: ''},
    {checklist: 'INSURANCE', result: ''},
    {checklist: 'FINANCIAL COUNSELLING', result: ''},
    {checklist: 'CO MORBIDS / MEDS', result: 'DM/HT/THYROID'},
    {checklist: 'HIGH RISK CONDITIONS', result: 'YES/ NO'}
  ]);

  let bmiValue = formData?.height && formData?.weight ? ((formData.weight / formData.height ** 2) * 10000).toFixed(2) : '';
  const labelStyles = {
    fontWeight: '600',
    marginRight: '5px',
    width: 'max-content'
  };

  const [showTables, setShowTables] = useState({
    checkList: true
  });

  const handleNill = id => {
    setShowTables(prev => ({...prev, [id]: false}));
  };

  const handleChange = e => {
    // const { name, value } = e.target;
    // setFormData({ ...formData, [name]: value });
    var text = e.target.value;

    if (e.target.name === 'patientId1') {
      if (/^(ASCAS|VDASCAS)\d+$/i.test((e.target.value || '').trim())) {
        const fetchData = async () => {
          const payload = {
            p_uhid: e.target.value
          };
          props.loaderchange('true');
          const addPatient = fetchPatientDetailsUuid(payload);
          const response = await dispatch(addPatient);
          if (response.payload?.status?.code === 200) {
            const data = response.payload.data.data[0];
            const namePat = data?.titles + ' ' + data?.first_name + ' ' + data?.last_name;
            if (e.target.name === 'patientId1') {
              setPatientOne_UUId(data?.id);
              setFormData({
                ...formData,
                patientName1: namePat,
                age1: data?.age,
                gender1: data?.gender,
                patientId1: text
              });
            }
            props.loaderchange('false');
          } else {
            props.loaderchange('false');
            props.popupalert('true');
            props.popuptext('Network went wrong, Please try after some time.');
            setTimeout(() => {
              props.popupalert('false');
            }, 2000);
          }
          return;
        };

        fetchData();
      } else {
        if (e.target.name === 'patientId1') {
          setFormData({
            ...formData,
            patientId1: e.target.value
          });
        }
      }
    } else {
      console.log('Going in');
      setFormData({...formData, [e.target.name]: e.target.value});
      if (e.target.name === 'nextappointment') {
        const dateTime = e.target.value.split('T');
        setAppointmentData({
          ...appointmentData,
          date: dateTime[0],
          time: dateTime[1],
          p_uhid: props.patientsData.p_uhid,
          name: `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`,
          status: 'Not Visited',
          notes: 'Booking Visit',
          patient_id: patientId
        });
      }
    }
  };

  const renderDiscPoint = () => (
    <span
      style={{
        fontSize: '30px',
        // lineHeight: "20px",
        display: 'flex',
        alignItems: 'center',
        height: '20px'
      }}>
      ●
    </span>
  );
  const renderIndentation = () => (
    <span
      style={{
        visibility: 'hidden',
        fontSize: '30px',
        lineHeight: '20px'
      }}>
      ●
    </span>
  );
  const renderReportfield = (name, value, options = {}) => {
    const {styleSec = {}, styleLabel = {}, styleSpan = {}} = options;

    return (
      <>
        <section style={{...styleSec, margin: '0 10px 10px 10px', display: 'flex'}}>
          <label
            style={{
              ...styleLabel,
              fontWeight: '600',
              marginRight: '5px',
              width: 'max-content'
            }}>
            {name}
          </label>
          <span style={styleSpan}>{value}</span>
        </section>
      </>
    );
  };

  const renderTableTD = value => {
    return <td style={{border: '1px solid black', textAlign: 'center'}}>{value}</td>;
  };
  const renderTableTH = value => {
    return <th style={{border: '1px solid black', textAlign: 'center'}}>{value}</th>;
  };
  const handlesubmit = () => {
    props.loaderchange('false');

    try {
      if (props.patientsData.id !== '' && props.patientsData.p_uhid !== '' && /^(ASCAS|VDASCAS)\d+$/i.test((props.patientsData.p_uhid || '').trim())) {
        setshow(true);
        // Set timeout to handle async report creation
        setTimeout(async () => {
          // Get HTML payload
          const htmlPayload = document.getElementById('PreOPCheckListReportGenerateWrap').innerHTML;

          const payload = {
            payload: {
              prescription_template: htmlPayload,
              patient_id: patientId,
              description: '',
              template_type: 'Pre OP Check List'
            }
          };

          // Dispatch action to create patient report
          props.loaderchange(true);
          const patentDetails = postPrescriptionTemplate(payload);
          const response = await dispatch(patentDetails);
          if (response?.payload?.status?.code === 200) {
            props.loaderchange(false);
            navigate('/PatientView');
            Swal.fire({
              title: 'Successful.',
              text: 'Record added successful.',
              icon: 'success',
              showConfirmButton: false,
              timer: 1500
            });
            props.loaderchange('false');
          } else {
            props.loaderchange('false');
            props.popupalert('true');
            props.popuptext('Network went wrong, Please try after some time.');
            // props.popuptext(response?.status?.message);
            setTimeout(() => {
              props.popupalert('false');
            }, 2000);
          }
        }, 3000);
      } else {
        // Show error message for invalid patient ids
        Swal.fire({
          title: 'Error.',
          text: 'Please enter valid patient id.',
          icon: 'error',
          showConfirmButton: false,
          timer: 1500
        });
      }
    } catch (error) {
      console.error('An error occurred:', error);
    }
  };

  return (
    <div id='PreOPCheckList'>
      <div className='PreOPCheckList'>
        <div className='' style={{width: '100%', display: 'block'}} id='patientInfo1'>
          <div style={{width: '100%'}}>
            <img
              className='header_image'
              src={headerimage}
              style={{
                // width: "100%", height: "25vh", maxHeight: show ? "100px" : "400px"

                width: '100%',
                margin: '0 auto'
              }}></img>
          </div>

          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              justifyContent: 'center',
              gap: '3px',
              backgroundColor: '#f7f7f7 ',
              borderRadius: '6px',
              padding: '16px 8px 16px 8px',
              gap: '3px'
            }}>
            <div style={{display: 'flex', gap: '16px', alignItems: 'center'}}>
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: '125px 16px 250px',
                  alignItems: 'center '
                }}>
                <span style={{fontWeight: 600}}>Patient ID</span>
                <span style={{fontWeight: 600}}>: </span>
                <input
                  type='text'
                  className={`createTime ${show ? 'hide' : 'show'}`}
                  value={props.patientsData.p_uhid}
                  onChange={e => handleChange(e)}
                  name='patientId'
                  style={{
                    border: '1px solid #ddd',
                    outline: 'none',
                    padding: '10px'
                  }}
                />
                <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{props.patientsData.p_uhid}</span>
              </div>
            </div>

            <div
              style={{
                display: 'grid',
                gridTemplateColumns: '125px 16px 250px',
                alignItems: 'center '
              }}>
              <span style={{fontWeight: 600}}>Patient Name</span>
              <span style={{fontWeight: 600}}>: </span>
              <input
                type='text'
                className={`createTime ${show ? 'hide' : 'show'}`}
                onChange={e => handleChange(e)}
                value={`${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`}
                name='patientName'
                style={{
                  border: '1px solid #ddd',
                  outline: 'none',
                  padding: '10px',
                  color: '#000'
                }}
              />
              <span className={`input ${!show ? 'hide' : 'show'}`} style={{width: '100%'}}>
                &nbsp;
                {`${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`}
              </span>
            </div>

            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '16px'
              }}>
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: '125px 16px 250px',
                  alignItems: 'center '
                }}>
                <span style={{fontWeight: 600}}>Gender</span>
                <span style={{fontWeight: 600}}>: </span>
                <select
                  className={`createTime ${show ? 'hide' : 'show'}`}
                  onChange={e => handleChange(e)}
                  value={props.patientsData.gender}
                  name='gender'
                  style={{
                    border: '1px solid #ddd',
                    outline: 'none',
                    padding: '10px',
                    backgroundColor: 'white'
                  }}>
                  <option value={props.patientsData.gender} selected>
                    {props.patientsData.gender}
                  </option>
                  <option value='Male'>Male</option>
                  <option value='Female'>Female</option>
                  <option value='Others'>Others</option>
                  <option value='Decline to State'>Decline to State</option>
                </select>
                <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{props.patientsData.gender}</span>
              </div>
            </div>

            <div
              style={{
                display: 'grid',
                gridTemplateColumns: '125px 16px 250px',
                alignItems: 'center '
              }}>
              <span style={{fontWeight: 600}}>Age</span>
              <span style={{fontWeight: 600}}>: </span>
              <input
                type='text'
                className={`createTime ${show ? 'hide' : 'show'}`}
                onChange={e => handleChange(e)}
                value={props.patientsData.age}
                name='age1'
                style={{
                  border: '1px solid #ddd',
                  outline: 'none',
                  padding: '10px'
                }}
              />
              <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{props.patientsData.age}</span>
            </div>
          </div>
        </div>

        <div className='row mt-2'>
          <h4 className='mt-4'>PATIENT INFORMATION</h4>

          <div className='col-md-4'>
            <ReportFormInputWithLabel label='Height :' name='height' value={formData.height} required={false} onChange={handleChange} inputClassName='show' endLabel='cm' />
          </div>

          <div className='col-md-4'>
            <ReportFormInputWithLabel label='Weight :' name='weight' value={formData.weight} required={false} onChange={handleChange} inputClassName='show' endLabel='kg' />
          </div>
          <div className='col-md-4'>
            <ReportFormInputWithLabel label='BMI :' name='bmi' value={bmiValue} required={false} onChange={handleChange} inputClassName='show' endLabel='kg/m2' />
          </div>
        </div>
        <div className='row mt-2'>
          <div className='col-md-4'>
            <ReportFormInputWithLabel label='PR :' name='pr' value={formData.pr} required={false} onChange={handleChange} inputClassName='show' endLabel='bpm' />
          </div>
          <div className='col-md-6'>
            <ReportFormInputWithLabel label='Blood Pressure (BP) :' name='bp' value={formData.bp} required={false} onChange={handleChange} inputClassName='show' endLabel='mmHg' minWidth='200px' />
          </div>
        </div>
        <div className='detail mt-3'>
          <h4>Pre OP Check List</h4>
        </div>

        {showTables.checkList && (
          <div className='detail'>
            <TemplateTable
              id='checkList'
              title=''
              headers={checkListHeaders}
              rows={checkListRows}
              onRowsChange={(id, newRows) => setCheckListRows(newRows)}
              enableActions={true}
              onNill={() => handleNill('checkList')}
            />
          </div>
        )}

        <div className='bulletin'>
          <h4>INSTRCUTIONS</h4>
          <ul className='px-3'>
            <li>NPO FROM</li>
            <li>INJ. TAXIM 1.5GM / INJ. XONE 1.5GM / INJ. SUPACEF 1.5GM BEFORE SHIFTING TO THEATRE</li>
            <li>INJ. PAN 40 MG IV 0.5 HOURS BEFORE PROCEDURE</li>
            <li>INJ. EMECET 4 MG IV 0.5 HOURS BEFORE PROCEDURE</li>
            <li>PREPARE YOUR PRIVATE PARTS BY SHAVING</li>
            <li>REMOVE ALL JEWELS / THALI — A YELLOW THREAD CAN BE USED</li>
            <li>IF DM – SKIP MORNING DOSE OF INSULIN / OHA</li>
            <li>IF THYROID – TAKE TABS WITH SIP OF WATER IN THE MORNING</li>
            <li>OTHER MEDS</li>
            <li>POST OP LMWH / SUGARS MONITORING</li>
            <li>
              ANY SPECIAL INSTRUCTIONS PRE-OP —&nbsp;
              <input
                className={`createTime ${show ? 'hide' : 'show'}`}
                name='special_instructions'
                onChange={handleChange}
                style={{border: '1px solid #ddd', outline: 'none', padding: '10px', width: '500px'}}
              />
              {/*   <textarea
                className='Textarea'
                placeholder='ARRANGE INSTRUMENTS /ARRANGE ASSITANT SURGEON/ FROZEN SECTION'
                id='special_instructions'
                name='special_instructions'
                onChange={handleChange}
                rows='4'
                cols='100'
              /> */}
              <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{formData.special_instructions}</span>
            </li>
          </ul>
        </div>

        <p className='pt-3' style={{fontWeight: '600'}}>
          NEXT APPOINTMENT - <input name='nextAppointment' onChange={handleChange} type='date' className={`createTime ${show ? 'hide' : 'show'}`} />
        </p>
        <div className={`Footer ${show ? 'hide' : 'show'}`}>
          <button onClick={handlesubmit} className='Button_Create'>
            Add Report
          </button>
        </div>
      </div>
      <div id='PreOPCheckListReportGenerate'>
        <div id='PreOPCheckListReportGenerateWrap'>
          <Headers />
          <p class='Dani'></p>
          <div
            className='patient'
            style={{
              border: '1px solid black',
              borderRadius: '10px',
              marginBottom: '10px'
            }}>
            <div className='nameToAgeContainer' style={{display: 'flex', marginBottom: '10px'}}>
              {renderReportfield('Patient Name :', `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`)}
              {renderReportfield('Patient ID :', props.patientsData.p_uhid)}
              {renderReportfield('Gender :', props.patientsData.gender)}
              {renderReportfield('Age :', props.patientsData.age)}
            </div>
          </div>

          <div style={{display: 'flex', marginTop: '10px'}}>
            <h4 style={{fontWeight: 600, marginRight: '5px'}}>PATIENT INFORMATION</h4>
          </div>
          <div style={{display: 'flex', marginTop: '10px'}}>
            {renderReportfield('Height :', `${formData.height ? formData.height : ''} cm`, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('Weight :', `${formData.weight ? formData.weight : ''} kg`, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('BMI :', `${bmiValue ? bmiValue : ''} kg/m2`, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('PR :', `${formData.pr ? formData.pr : ''} bpm`, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('Blood Pressure (BP) :', `${formData.bp ? formData.bp : ''} mm Hg`, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
          </div>
          {showTables.checkList && (
            <>
              <div style={{display: 'flex', marginTop: '10px'}}>
                <h4 style={{fontWeight: 600, marginRight: '5px'}}>PRE OP CHECKLIST</h4>
              </div>

              <div>
                <table
                  style={{
                    marginBottom: '10px',
                    border: '1px solid black',
                    width: '100%',
                    textAlign: 'center'
                  }}>
                  <thead>
                    <tr>{checkListHeaders.map((ele, ind) => renderTableTH(ele.label))}</tr>
                  </thead>
                  <tbody>
                    {checkListRows.map((row, i) => (
                      <tr key={i}>
                        {renderTableTD(row.checklist)}
                        {renderTableTD(row.result)}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          )}

          <div style={{display: 'flex', marginBottom: '10px'}}>{renderReportfield('INSTRCUTIONS', '', {styleSec: {width: '100%'}})}</div>
          {[
            'NPO FROM',
            'INJ. TAXIM 1.5GM / INJ XONE 1.5GM / INJ. SUPACEF 1.5 GM BEFORE SHIFTING TO THEATRE',
            'INJ. PAN 40 MG IV 0.5 HOURS BEFORE PROCEDURE',
            'INJ. EMECET 4 MG IV 0.5 HOURS BEFORE PROCEDURE',
            'PREPARE YOUR PRIVATE PARTS BY SHAVING',
            'REMOVE ALL JEWELS / THALI AND A YELLOW THREAD CAN BE USED',
            'IF DM – SKIP MORNING DOSE OF INSULIN / OHA',
            'IF THYROID – TAKE TABS WITH SIP OF WATER IN THE MORNING',
            'OTHER MEDS',
            `ANY SPECIAL INSTRUCTIONS PRE OP – ${formData.special_instructions ? formData.special_instructions : ''}`,
            'POST OP LMWH / SUGARS MONITORING'
          ].map((ele, ind) => {
            return (
              <div style={{display: 'flex', marginBottom: '10px'}}>
                {renderIndentation()}
                {renderDiscPoint()}
                {renderReportfield(ele, '', {styleSec: {width: '100%'}})}
              </div>
            );
          })}

          <div style={{marginTop: '10px'}}>{renderReportfield('Next Appointment : ', appointmentData.date?.split('-').reverse().join('-'))}</div>
          <p class='Dani'></p>
          <PrescriptionFooter />
        </div>
      </div>
    </div>
  );
}
